import React, { useEffect } from 'react';
import { usePlantAndLinesStore } from '../../providers/PlantAndLinesStore/PlantAndLinesStore';
import { callFunctionConditionallyWithWarningCurry } from '../../utils/utils';
import styles from './LineDropdownSelector.module.css';
import Select from 'react-select';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const AggregateLineDropDownSelector = ({
  hasActiveEdits,
  isDarkStyle,
  height = 30,
}) => {
  const [
    aggregateLine,
    setAggregateLine,
  ] = usePlantAndLinesStore().aggregateLineState;

  const [aggregateLineOptions] = usePlantAndLinesStore().aggregateLineOptions;

  const handleLineChange = valueObject => {
    setAggregateLine(valueObject);
  };

  const customStyles = {
    control: provided => ({
      ...provided,
      width: 120,
      minWidth: 120,
      height: height,
      minHeight: height,
      fontSize: '12px',
      background: 'none',
      paddingTop: 0,
      paddingBottom: 0,
    }),
    option: (provided, state) => ({
      ...provided,
      width: 120,
      minWidth: 120,
      height: 30,
      minHeight: 30,
      fontSize: '12px',
    }),
    dropdownIndicator: provided => ({
      ...provided,
      width: 30,
      paddingTop: 0,
      paddingBottom: 0,
    }),
    indicatorSeparator: () => ({ display: 'none' }),
  };

  useEffect(() => {
    aggregateLineOptions.sort((a, b) => {
      if (a.label && b.label) {
        return a.label.localeCompare(b.label, 'en', { numeric: true });
      }
    });
  }, [aggregateLineOptions]);

  return (
    <Select
      value={aggregateLine}
      styles={customStyles}
      className={clsx(styles.dropdown, isDarkStyle && styles.dropdownDark)}
      classNamePrefix="select-line"
      onChange={callFunctionConditionallyWithWarningCurry(
        handleLineChange,
        hasActiveEdits,
      )}
      options={aggregateLineOptions}
    />
  );
};

AggregateLineDropDownSelector.prototypes = {
  hasActiveEdits: PropTypes.bool,
  isDarkStyle: PropTypes.bool,
  height: PropTypes.number,
};
export default AggregateLineDropDownSelector;
